import { api, authHeader } from "../configs/axiosConfigs";

const resolveBaseUrl = (source) =>
  source === "Management"
    ? "/SLN/Management/MehrsanWorkQueue"
    : "/SLN/SolarentOperator/MehrsanWorkQueue";

const MehrsanWorkQueueApi = {
  getFilterData: async (source = "SolarentOperator") => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/GetFilterData`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  search: async (source = "SolarentOperator", searchParams = {}) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Search`,
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return response.data;
  },

  assign: async (source = "SolarentOperator", requestId, assignedToUserId = null) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Assign`,
      method: "POST",
      headers: authHeader(),
      data: { requestId, assignedToUserId },
    });
    return response.data;
  },

  /**
   * آپلود خروجی اکسل پورتال مهرسان.
   * @param {File} file
   * @param {boolean} confirm false=پیش‌نمایش، true=اعمال
   */
  importPortalExcel: async (source = "SolarentOperator", file, confirm = false) => {
    if (!file) {
      throw new Error("فایل اکسل انتخاب نشده است.");
    }
    const formData = new FormData();
    formData.append("file", file, file.name || "InstallationRequests.xlsx");
    formData.append("confirm", confirm ? "true" : "false");

    // مثل DefaultApiService.uploadFile / ImportSeedExcel:
    // Content-Type را ست نکنید تا boundary توسط مرورگر اضافه شود.
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/ImportPortalExcel`,
      method: "POST",
      headers: authHeader(),
      data: formData,
    });
    return response.data;
  },
};

export default MehrsanWorkQueueApi;
